import request from '@/utils/request'
import locale from './../lang/i18n'
import { adminPath, getSettings, paged, saveSettings, updateSettings, uploadMedia } from './adminV1'

function publicLocale () {
  return locale.locale === 'en-US' ? 'en' : 'zh-cn'
}

export function settingTopBackground (file) {
  return uploadMedia(file, 'image')
    .then(media => updateSettings({ contactTopImage: media.url }))
    .then(data => ({ code: 0, data }))
}

export function getTopBackground () {
  return getSettings().then(data => ({ code: 0, data: { value: data.contactTopImage || '' } }))
}

export function getWebTopBackground () {
  return request({ url: `/api/public/v1/${publicLocale()}/media/CONTACT_US_TOP_IMG`, method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function submitMessage (data) {
  return request({
    url: `/api/public/v1/${publicLocale()}/inquiries`,
    method: 'post',
    data: {
      sessionToken: data.sessionId,
      company: data.company,
      name: data.name,
      phone: data.phone,
      email: data.email,
      wechat: data.wechat,
      whatsapp: data.whatsapp,
      message: data.content || data.context
    }
  }).then(result => ({
    code: 0,
    data: { ...result, sessionId: result.sessionToken }
  }))
}

export function getSessionList (query) {
  return request({ url: adminPath('/inquiries'), method: 'get' }).then(list => {
    const page = paged(list, query || {})
    return { code: 0, data: { rows: page.rows, total: page.total } }
  })
}

export function setReadStatus (id) {
  return request({ url: adminPath(`/inquiries/${id}/read`), method: 'put' })
    .then(() => ({ code: 0 }))
}

export function deleteSession (id) {
  return request({ url: adminPath(`/inquiries/${id}`), method: 'delete' })
    .then(() => ({ code: 0 }))
}

export function getUnreadCount () {
  return request({ url: adminPath('/inquiries/unread-count'), method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function getRobotConfig () {
  return getSettings().then(settings => ({
    code: 0,
    data: {
      enable: settings.autoReplyEnabled ? 1 : 0,
      content: settings.autoReplyContent || ''
    }
  }))
}

export function getWebRobotConfig () {
  return request({ url: `/api/public/v1/${publicLocale()}/settings`, method: 'get' }).then(settings => ({
    code: 0,
    data: {
      enable: settings.autoReplyEnabled ? 1 : 0,
      content: settings.autoReplyContent || ''
    }
  }))
}

export function updateRobotConfig (data) {
  return updateSettings({
    autoReplyEnabled: Boolean(data.enable),
    autoReplyContent: data.content || ''
  }).then(result => ({ code: 0, data: result }))
}

export function getAdminSessionMessages (sessionId) {
  return request({ url: adminPath(`/inquiries/${sessionId}`), method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function replySessionMessage (data) {
  return request({
    url: adminPath(`/inquiries/${data.sessionId}/replies`),
    method: 'post',
    data: { message: data.content }
  }).then(result => ({ code: 0, data: result }))
}

export function getWebSessionMessages (sessionToken) {
  return request({
    url: `/api/public/v1/${publicLocale()}/inquiries/${encodeURIComponent(sessionToken)}/messages`,
    method: 'get'
  }).then(data => ({ code: 0, data }))
}

export function getContactInfo () {
  return request({ url: `/api/public/v1/${publicLocale()}/settings`, method: 'get' })
    .then(settings => ({ code: 0, data: contact(settings) }))
}

export function getAdminContactInfo () {
  return getSettings().then(settings => ({ code: 0, data: contact(settings) }))
}

export function setContactInfo (data) {
  return getSettings().then(settings => saveSettings({
    ...settings,
    contactTel: data.tel,
    contactName: data.name,
    contactPhone: data.phone,
    contactEmail: data.email,
    contactWechat: data.wechat,
    contactWhatsapp: data.whatsapp
  })).then(result => ({ code: 0, data: result }))
}

function contact (settings) {
  return {
    tel: settings.contactTel || '',
    name: settings.contactName || '',
    phone: settings.contactPhone || '',
    email: settings.contactEmail || '',
    wechat: settings.contactWechat || '',
    whatsapp: settings.contactWhatsapp || ''
  }
}
